export function addControlButtonsToBottomRight(
  map: google.maps.Map,
  ref?: React.MutableRefObject<HTMLDivElement | null>,
): void {
  if (ref?.current) map?.controls[google.maps.ControlPosition.RIGHT_BOTTOM]?.push(ref.current);
}

export function addControlButtonsToTopRight(
  map: google.maps.Map,
  ref?: React.MutableRefObject<HTMLDivElement | null>,
): void {
  if (ref?.current) map?.controls[google.maps.ControlPosition.TOP_RIGHT]?.push(ref.current);
}
